module.exports = __webpack_public_path__ + "static/media/UsdtIcon.e4f8f24c.svg";